function initIdea() {
  const ideaSlider = document.querySelector('.idea__slider');

  if (ideaSlider && document.documentElement.clientWidth > 1023) {
    const swiper = new Swiper(ideaSlider, {
      slidesPerView: 'auto',
      spaceBetween: 16,

      navigation: {
        nextEl: '.idea__slider-controls .swiper-controls__btn--next',
        prevEl: '.idea__slider-controls .swiper-controls__btn--prev',
      },
    })
  }
}

export { initIdea };
